export default __webpack_public_path__ + "static/media/aboutimg4.b4ddaa1f.webp";